import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import PaperDialogForm from './_PaperDialogForm';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import { notifySomething } from '../_Utils/AppDocuCommon';

export default class EditPaperDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: null,
      loading: false,
    };
  }

  async componentDidMount() {
    if (this.props.itemId) {
      await this.loadItem(this.props.itemId);
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.itemId && this.props.itemId !== prevProps.itemId) {
      await this.loadItem(this.props.itemId);
    }
    if (!this.props.itemId && prevProps.itemId) {
      this.setState({ itemData: null, loading: false });
    }
  }

  loadItem = async (id) => {
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.getPaper(id);
      const paper = res.data.paper || {};
      this.setState({ itemData: paper, loading: false });
    } catch (e) {
      this.setState({ loading: false });
      notifySomething('Error loading paper data', 'error');
    }
  };

  handleUpdate = async () => {
    const m = /** @type {any} */ (this.state.itemData || {});
    if (!m.title || !m.title.trim()) {
      notifySomething('Title is required', 'warning');
      return;
    }
    try {
      const res = await AppDocuServiceCall.updatePaper({
        id: m.id,
        title: m.title,
        content: m.content || '',
        com_brand: m.com_brand || null,
        published: m.published || 0,
      });
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error updating paper', 'error');
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error updating paper:', error);
      notifySomething('Error updating paper', 'error');
    }
  };

  render() {
    const { itemData, loading } = this.state;
    return (
      <>
        {loading || !itemData ? (
          <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="md" fullWidth>
            <DialogTitle>Edit Paper</DialogTitle>
            <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}>
                <CircularProgress size={40} thickness={4} />
              </div>
            </DialogContent>
          </Dialog>
        ) : (
          <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="xl" fullWidth>
            <DialogTitle>Edit Paper</DialogTitle>
            <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
              <PaperDialogForm
                itemData={itemData}
                onChange={newData => this.setState({ itemData: newData })}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.props.onClose}>Cancel</Button>
              <Button onClick={this.handleUpdate} color="primary" disabled={loading || !itemData}>Update</Button>
            </DialogActions>
          </Dialog>
        )}
      </>
    );
  }
}
